import { ProjectEntity } from "@archipad-models/models/ProjectEntity";

export function isBugWorkflowEnabled(project:ProjectEntity) {
    return project?.isBugWorkflowEnabled ?? false;
}

export function isBugWorkflowComplexProject(project:ProjectEntity): boolean {
    return project?.bugWorkflow?.bugGroups?.length > 0;
}